import type { ReactNode } from 'react';

export function Card({ className = '', hoverable = false, children }: { className?: string; hoverable?: boolean; children: ReactNode }) {
  return (
    <div
      className={`bg-white rounded-2xl border border-border-subtle shadow-card transition-shadow duration-300 ease-premium ${
        hoverable ? 'hover:shadow-card-hover' : ''
      } ${className}`}
    >
      {children}
    </div>
  );
}

export function CardHeader({
  title,
  subtitle,
  icon,
  action,
}: {
  title: string;
  subtitle?: string;
  icon?: ReactNode;
  action?: ReactNode;
}) {
  return (
    <div className="flex items-center justify-between gap-3 px-5 py-4 border-b border-border-subtle">
      <div className="flex items-center gap-3 min-w-0">
        {icon && (
          <div className="w-8 h-8 flex items-center justify-center rounded-[10px] bg-gradient-to-br from-primary-50 to-primary-100 text-primary-800 ring-1 ring-inset ring-primary-100 flex-shrink-0">
            {icon}
          </div>
        )}
        <div className="min-w-0">
          <p className="text-[14px] font-bold text-ink tracking-tight truncate">{title}</p>
          {subtitle && <p className="text-[11.5px] text-ink-faint truncate">{subtitle}</p>}
        </div>
      </div>
      {action}
    </div>
  );
}

export function CardBody({ className = '', children }: { className?: string; children: ReactNode }) {
  return <div className={`p-5 ${className}`}>{children}</div>;
}
